import { Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PaymentTermsAndConditions from '../../../checkout/components/paymentTermsAndConditions';
import LocaleKeys from '../../../locales/keys';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    width: '50%',
  },
  button: {
    color: '#fff',
    borderRadius: '5px',
    margin: '0',
    fontWeight: 500,
    letterSpacing: 0.5,
    lineHeight: 1,
    padding: '12px 15px',
  },

  saveButton: {
    marginTop: 0,
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      boxShadow: `0 0 0 2px ${theme.palette.custom.darkRed} inset`,
      color: theme.palette.custom.lightBlack,
      background: theme.palette.custom.white,
    },
    '&:disabled': {
      backgroundColor: theme.palette.custom.frame,
    },
  },
}));

const StripeCompleteOrderButtonAction = ({
  paymentTermsAndConditions,
  paymentFormName,
  handlePaymentTermsAndConditionChecked,
  isLoading,
  stripe,
  elements,
  isCompleteOrderButtonDisabled,
  handleSubmit,
  submitOrderUpdateCountryFault = '',
  setPaymentTermsAndConditions,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  useEffect(() => {
    if (submitOrderUpdateCountryFault) {
      setPaymentTermsAndConditions({ paymentTermsAndConditions: false });
    }
  }, [submitOrderUpdateCountryFault]);
  return (
    <>
      <Box mb={5}>
        <PaymentTermsAndConditions
          formData={paymentTermsAndConditions}
          formName={paymentFormName}
          privacyPolicyText={t(LocaleKeys.payment.orders.orderPrivacyPolicy)}
          handleSave={handlePaymentTermsAndConditionChecked}
          subscriptionDisclaimText={t(
            LocaleKeys.payment.orders.subscriptionDisclaimText,
          )}
        />
      </Box>
      <Box className={classes.buttonContainer} pl={4}>
        <Button
          className={`${classes.button} ${classes.saveButton}`}
          disabled={
            isLoading || !stripe || !elements || isCompleteOrderButtonDisabled
          }
          id="submit"
          onClick={handleSubmit}
        >
          {t(LocaleKeys.payment.orders.completeOrder)}
        </Button>
      </Box>
    </>
  );
};

export default StripeCompleteOrderButtonAction;
